import React from 'react'

function Button({name, onClick}) {
  return (
    <>
    <button 
      className=' bg-text-color1   px-5 py-2.5 border-none rounded-lg font-bold text-white'
      onClick={onClick}
      type='submit' 
     >{name}</button>   
    {/* <button 
      className=' bg-primary-color   px-5 py-2.5 border-none rounded-lg font-bold text-white'
      onClick={onClick}
      type='submit' 
     >{name}</button>    */}
    </>
  )
}

export default Button